import { Callback, Dict } from '@/types/utility';
import SocketCentrifugeBase from '@/api/sockets/SocketCentrifugeBase';

export type SocketResponseError = {
  code: number | string;
};

export enum NotificationSocketEvents {
  ERROR = 'error',
}

export default class NotificationSocket extends SocketCentrifugeBase<
  NotificationSocketEvents,
  never
> {
  private static connections: Dict<NotificationSocket> = {};

  protected listeners: Record<NotificationSocketEvents, Callback[]> = {
    [NotificationSocketEvents.ERROR]: [],
  };

  private constructor(
    private email: string,
    onConnect?: Callback<[SocketCentrifugeBase<NotificationSocketEvents, never>]>,
  ) {
    super(`personal:notify#${email}`, {
      handleEvents: ({ data }) => {
        switch (data.event) {
          case NotificationSocketEvents.ERROR: {
            this.callListeners(NotificationSocketEvents.ERROR, data);
            break;
          }
        }
      },
      onConnect,
    });
  }

  public static start(
    email: string,
    onConnect?: Callback<[SocketCentrifugeBase<NotificationSocketEvents, never>]>,
  ) {
    const connection = NotificationSocket.connections[email];
    if (connection) {
      connection.addSession();
      onConnect?.(connection);
      return connection;
    }

    NotificationSocket.connections[email] = new NotificationSocket(email, onConnect);
    return NotificationSocket.connections[email];
  }

  public close(listenersGroupId?: string): boolean {
    const isClosed = super.close(listenersGroupId);

    if (isClosed) {
      delete NotificationSocket.connections[this.email];
    }

    return isClosed;
  }
}
